import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { H1, Container, Col, Row } from '@everlywell/leaves';

import { Theme, Themable } from '../../Themable';

import lines from './4lines.svg';
import ornaments from '../../../images/themes/Winter2020/ornaments.svg';

import * as S from './styles';

type PageHeadingProps = {
  headline?: string;
  subHeadline?: string;
};

export const PurePageHeading: React.FC<PageHeadingProps> = ({
  headline,
  subHeadline,
}) => {
  return (
    <Container>
      <Row>
        <Col xs={12}>
          <Themable>
            <S.Img
              theme={Theme.Default}
              src={lines}
              aria-hidden="true"
              alt="decorative lines"
              width={90}
              height={72}
            />
            <S.Img
              theme={Theme.Winter2020}
              src={ornaments}
              aria-hidden="true"
              alt="decorative ornaments"
            />
          </Themable>
        </Col>
      </Row>
      <Row center="xs">
        <Col xs={12}>
          {headline ? <H1>{headline}</H1> : null}
          {subHeadline ? <S.Disclaimer>{subHeadline}</S.Disclaimer> : null}
        </Col>
      </Row>
    </Container>
  );
};

export const PageHeading = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          contentfulPageSection(sectionId: { eq: "PIP - Page Heading" }) {
            headline
            subHeadline
          }
        }
      `}
      render={(contentfulData) => {
        const { contentfulPageSection: data } = contentfulData;
        return (
          <PurePageHeading
            headline={data.headline}
            subHeadline={data.subHeadline}
          />
        );
      }}
    />
  );
};

export default PageHeading;
